const getPIData = (state) => (payload) => {
  const { dataFormat } = payload;
  const { type } = payload;
  const { comparison } = payload;
  const { rareMode } = payload;

  const returnObject = {
    data: [],
    labels: [],
  };

  let sortableArray = [];
  const NAarray = [];

  Object.entries(state.performanceIndexChartData[comparison])
    .forEach(([key, value]) => {
      if ((value[dataFormat] === 'N/A' || value[dataFormat] === 0) && key !== 'industry_average') {
        NAarray.push(
          {
            labels: key,
            data: value[dataFormat],
          },
        );
      } else if (dataFormat === 'decimal' && key === 'industry_average') {
        // blank
      } else {
        sortableArray.push(
          {
            labels: key,
            data: value[dataFormat],
          },
        );
      }
    });

  sortableArray.sort((a, b) => a.data - b.data);
  sortableArray.reverse();

  if (rareMode === true) {
    sortableArray = sortableArray.concat(NAarray);
  }

  sortableArray.forEach((object) => {
    returnObject.data.push(object.data);
    returnObject.labels.push(object.labels);
  });

  if (type === 'object') {
    return returnObject;
  } else { // eslint-disable-line
    return returnObject[type];
  }
};
const getPITableData = (state) => (payload) => {
  function checkValue(value) {
    let returnValue = value;
    if (value === 'N/A') {
      returnValue = -1;
    }
    return returnValue;
  }

  const { dataFormat } = payload;
  const returnArray = [];

  Object.entries(state.performanceIndexChartData.base).forEach(([key, obj]) => {
    const clientName = key;
    const base = checkValue(obj[dataFormat]);
    const prevYear1 = checkValue(state.performanceIndexChartData.prevYear1[key][dataFormat]);
    const prevYear2 = checkValue(state.performanceIndexChartData.prevYear2[key][dataFormat]);
    const prevYear3 = checkValue(state.performanceIndexChartData.prevYear3[key][dataFormat]);

    returnArray.push({
      clientName,
      base,
      prevYear1,
      prevYear2,
      prevYear3,
    });
  });

  returnArray.sort((obj1, obj2) => obj1[state.tableSortColumn] - obj2[state.tableSortColumn]);
  returnArray.reverse();

  const clientNameArray = [];
  const baseDataArray = [];
  const prevYear1Array = [];
  const prevYear2Array = [];
  const prevYear3Array = [];

  returnArray.forEach((object) => {
    clientNameArray.push(object.clientName);
    baseDataArray.push(object.base);
    prevYear1Array.push(object.prevYear1);
    prevYear2Array.push(object.prevYear2);
    prevYear3Array.push(object.prevYear3);
  });

  return {
    clientNameArray,
    baseDataArray,
    prevYear1Array,
    prevYear2Array,
    prevYear3Array,
  };
};
const pIDisplayMode = (state) => state.pIDisplayMode;
const pIPageMaxPercent = (state) => state.pIPageMaxPercent;
const pIPageMaxDecimal = (state) => state.pIPageMaxDecimal;
const pILegendData = (state) => state.pILegendData;
const tableSortColumn = (state) => state.tableSortColumn;

export default {
  getPIData,
  getPITableData,
  pIDisplayMode,
  pIPageMaxPercent,
  pIPageMaxDecimal,
  pILegendData,
  tableSortColumn,
};
